import React, { lazy, Suspense, useState, useEffect } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import LoadingIndicator from '../LoadingIndicator';
import retry from '../utils/webpack/chunkRetry';
var VideoPlayerLazy = lazy(function () {
    return retry(function () { return import(/* webpackChunkName: "playable" */ 'react-playable'); });
});
export var VideoPlayer = function (_a) {
    var width = _a.width, height = _a.height, src = _a.src, className = _a.className, autoPlay = _a.autoPlay, loadingCover = _a.loadingCover, fillAllSpace = _a.fillAllSpace, onInit = _a.onInit;
    var _b = useState(false), mounted = _b[0], setMounted = _b[1];
    useEffect(function () {
        setMounted(true);
    }, []);
    var onPlayerInit = function (player) {
        // Disable picture in picture feature control.
        // Fullscreen affects devpage's own fullscreen so it's disabled as well.
        player.hidePictureInPictureControl();
        player.hideFullScreenControl();
        onInit && onInit(player);
    };
    return (React.createElement(ErrorBoundary, { debugComponent: "VideoPlayer" },
        mounted && (React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, { coverMode: true }) },
            React.createElement("div", { className: className },
                React.createElement(VideoPlayerLazy, { src: src, autoplay: autoPlay, fillAllSpace: fillAllSpace, poster: loadingCover, onInit: onPlayerInit, width: width, height: height })))),
        React.createElement("noscript", null,
            React.createElement("video", { width: width || 640, height: height || 480, controls: true, src: src }))));
};
VideoPlayer.displayName = 'VideoPlayer';
//# sourceMappingURL=LoadableVideoPlayer.js.map